import { Static, Type } from "@sinclair/typebox";

export const ThreadMessagesResponse = Type.Object({
  wpid: Type.String(),
  status: Type.Boolean(),
  msgIds: Type.Optional(Type.Array(Type.String())),
  msgIdLatestUpdate: Type.Optional(Type.Record(Type.String(), Type.Union([Type.Number(), Type.Null()]))),
});

export type ThreadMessagesResponseType = Static<typeof ThreadMessagesResponse>;
